// extracted by mini-css-extract-plugin
export default {"fixedSocialMediaBar":"FixedSocialBar_fixedSocialMediaBar__nRSg8","icon":"FixedSocialBar_icon__Kiv8d"};